import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';

/**
 * Initialise AOS (Animate On Scroll) une fois, puis recalcule les
 * animations à chaque changement de page (le contenu change avec les routes).
 * À placer juste en dessous du <Router> dans App.js.
 */
export default function AnimationManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: 'ease-out-cubic',
      once: true,
      offset: 60,
    });
  }, []);

  useEffect(() => {
    // Laisse le DOM de la nouvelle page se rendre avant de recalculer
    const id = setTimeout(() => AOS.refreshHard(), 50);
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    return () => clearTimeout(id);
  }, [pathname]);

  return null;
}
